import { z } from 'zod';

/**
 * Lifecycle of a row in the shared domain-event outbox (ADR-052).
 *
 * - `pending`: waiting for its first publish or its next retry.
 * - `in_flight`: claimed by one dispatcher under a lease.
 * - `dispatched`: published; kept for a short window, then pruned.
 * - `parked`: gave up after the retry budget; kept until an operator replays it.
 */
export const DOMAIN_EVENT_OUTBOX_STATUSES = [
  'pending',
  'in_flight',
  'dispatched',
  'parked',
] as const;
export const domainEventOutboxStatusSchema = z.enum(DOMAIN_EVENT_OUTBOX_STATUSES);
export type DomainEventOutboxStatus = z.infer<typeof domainEventOutboxStatusSchema>;

/** The longest envelope id the outbox stores (its primary key). */
export const DOMAIN_EVENT_OUTBOX_ID_MAX_LENGTH = 128;
/** The longest catalogued event type the outbox stores. */
export const DOMAIN_EVENT_OUTBOX_EVENT_TYPE_MAX_LENGTH = 128;
/** The longest error class recorded against a failed attempt. */
export const DOMAIN_EVENT_OUTBOX_ERROR_CLASS_MAX_LENGTH = 200;
